import React from 'react'
import Hero from '../components/Hero'
import About from '../components/About'
import Reviews from '../components/Reviews'
import DownloadSection from '../components/Download'
import Footer from '../components/Footer'
import Faq from '../components/Faq'
import Contact from '../components/Contact'

const Home = () => {
    return (
        <div className='flex-grow'>
            <Hero />
            <About />
            <Reviews />
            <DownloadSection />
            <Contact />
            <Faq />
        </div>
    )
}

export default Home
